export { default } from './CarsStockBanner';
